module.exports = __webpack_public_path__ + "static/media/heart.b06bc177.svg";